/**
 * @generated SignedSource<<d175c27836d36977d9c6e0141b71cba7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LogoNav_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly isVip: boolean | null;
  readonly " $fragmentType": "LogoNav_user";
};
export type LogoNav_user$key = {
  readonly " $data"?: LogoNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"LogoNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LogoNav_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c38e8fda0f14fbab9a0858ed2d91baf";

export default node;
